import musicOnlyVtt from '../assets/vtt/music-only.vtt'

export enum VideoStatus {
  processing = 0,
  live = 1,
  deleted = 2
}

export enum AdUnit {
  adhesion = 'adhesion_video',
  sticky = 'sticky_video',
  video = 'video'
}

export enum SourceFormat {
  h264 = 'video/mp4; codecs="avc1.42E01E"',
  h265 = 'video/mp4; codecs="hevc"',
  vp9 = 'video/webm; codecs="vp9"',
}

export enum SourceType {
  dash = 'application/dash+xml',
  hls = 'application/x-mpegURL'
}

// Default Track comes from site.video_settings.default_vtt
// 0=nothing, 1=music only track
export const defaultTrackMap: {[key: number]: videojs.default.TextTrackOptions } = {
  1: {
    default: true,
    kind: 'captions',
    label: '',
    src: musicOnlyVtt,
    srclang: 'en'
  }
}

export const DEFAULT_VOLUME = 0.7
export const DEFAULT_VIEWPORT_HEIGHT = 728


export const ADHESION_TIMEOUT = 2000
export const AUTOPLAY_CUSTOM = 3
export const AUTOPLAY_DESKTOP = 2
export const AUTOPLAY_MOBILE = 1
export const BELOW_THE_FOLD = 728
export const CATEGORY_SUBSTRING_LENGTH = 40

export const DURATION_FOR_IMPRESSION = 3000
export const IU_ID = 1030006
export const MIN_WIDTH_FOR_UPNEXT_DIALOG = 450
export const MINI_HEIGHT_MOBILE = 144
export const MINI_WIDTH_MOBILE = 256
export const MINI_HEIGHT_DESKTOP = 174
export const MINI_WIDTH_DESKTOP = 310
export const MOBILE_WIDTH_BREAKPOINT = 400
export const VOLUME_DIVISOR = 100.0
export const PROGRAMMATIC = 'programmatic'
export const USER = 'user'
